import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { CardSelector } from "../../common/card"
import { InventoryConfigurationAction } from "../../state/inventory/configuration/actions"
import { INVENTORY_COST_METHOD } from "../../state/inventory/configuration/models"
import { InventoryConfigurationSelector } from "../../state/inventory/configuration/selectors"
import { COST_METHOD_OPTIONS } from "../../utils/inventory/utils"

export const CostMethodSelector = () => {
    const dispatch = useDispatch()
    const costMethod = useSelector(InventoryConfigurationSelector.getCostMethod)

    const onChange = (selection: string) => {
        if (selection !== costMethod) {
            dispatch(InventoryConfigurationAction.update({
                costMethod: selection as INVENTORY_COST_METHOD
            }))
        }
    }

    return (
        <div>
            <CardSelector
                options={COST_METHOD_OPTIONS}
                selectedOption={costMethod}
                onChangeCallback={onChange}
            />
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/inventory/components/CostMethodSelector.tsx